import { createContext } from 'react';

export type ExpandableContextValue = {
    contentId: string;
    open: boolean;
    setOpen: (open: boolean) => void;
    setOverflowing: (overflowing: boolean) => void;
};

export const ExpandableContext = createContext<ExpandableContextValue | undefined>(undefined);
